module.exports = __webpack_public_path__ + "static/media/210-Mitpatient_ID_19.aae8c7bd.mp3";